module.exports = __webpack_public_path__ + "static/Juxtapose-Scribe-Agency-a125c9e531b958e5bc62d26e674ac1cd.png";